__turbopack_context__.v({
  "eyebrow": "BlockSimpleCards-module-scss-module__zOYp_q__eyebrow",
  "fade-in": "BlockSimpleCards-module-scss-module__zOYp_q__fade-in",
  "flushBottom": "BlockSimpleCards-module-scss-module__zOYp_q__flushBottom",
  "flushTop": "BlockSimpleCards-module-scss-module__zOYp_q__flushTop",
  "listItem": "BlockSimpleCards-module-scss-module__zOYp_q__listItem",
  "productItem": "BlockSimpleCards-module-scss-module__zOYp_q__productItem",
  "productList": "BlockSimpleCards-module-scss-module__zOYp_q__productList",
  "root": "BlockSimpleCards-module-scss-module__zOYp_q__root",
});
